export class QuotationLine {
    sequence: number;
    code: string;
    invoiceableItemParentCode: string;
    subGroupCode?: string;
    testBundleCode?: string;
    sampleCodes?: string[] = [];
    comment?: string;
    isMandatory?: boolean;
    executionNumber?:number;
}
